/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetGipReportEvidenceExportUrl1QueryResponse, GetGipReportEvidenceExportUrl1PathParams, GetGipReportEvidenceExportUrl1404 } from "../models/GetGipReportEvidenceExportUrl1";

export function getGetGipReportEvidenceExportUrl1Url(id: GetGipReportEvidenceExportUrl1PathParams["id"]) {
  const res = { method: 'GET', url: `/reports/gip/report/${id}/export-url` as const }
  return res
}

/**
 * @summary Get export URL for existing report
 * {@link /reports/gip/report/:id/export-url}
 */
export async function getGipReportEvidenceExportUrl1(id: GetGipReportEvidenceExportUrl1PathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetGipReportEvidenceExportUrl1QueryResponse, ResponseErrorConfig<GetGipReportEvidenceExportUrl1404>, unknown>({ method : "GET", url : getGetGipReportEvidenceExportUrl1Url(id).url.toString(), ... requestConfig })
  return res.data
}